import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Game from './components/Game';
import GameInstructions from './components/GameInstructions';
import GameEnd from './components/GameEnd';
import './style.css';
import sequence from './sequence.json';
import Loader from '../Loader';
import Flasher from './components/Flasher';
import api from '../../api';
import nijiLogo from '../../assets/images/Logo.png';

const gameConfig = {
  // gameColor: 'blue', // Background color
  // feedbackColor: 'yellow', // Box color
  roundsAmount: sequence.length,
  // triesAmount: 2,
  timeToRespond: 2000,
  // timeToRespond: 0,
  timeBetweenRound: 250, // Time between responses (reduced for quicker next key)
  boxesAmount: 4, // Number of boxes
  letterHint: false,
  possibleKeys: ['C', 'V', 'N', 'M'],
  // letterHint: true, // If the letter is shown on the box
  letterPerBox: sequence,
};

const MainGame = () => {
  const isFinalized = localStorage.getItem('niji-finalized') === 'true';
  const [gameStarted, setGameStarted] = useState(false);
  const [gameEnded, setGameEnded] = useState(false);
  const [gameResults, setGameResults] = useState([]);
  const [practiceData, setPracticeResults] = useState([]);
  const [screenFlashed, setScreenFlashed] = useState(false);
  const passedGamesCount = (useQuery as any)('passedGamesCount', api.game.getPassedGamesCount, {
    retry: false,
    retryDelay: 0,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });

  const flashScreen = () => {
    setScreenFlashed(true);
  };

  const resetTest = () => {
    localStorage.setItem('niji-skip-to-begin', 'true');
    window.location.reload();
  };

  const startGame = () => {
    setGameStarted(true);
  };

  const endGame = async (results) => {
    setGameResults(results);
    setGameStarted(false);
    setGameEnded(true);
  };

  // Game starts when user clicks the instructions screen.

  if (isFinalized) {
    return (
      <div className="instructions-container instructions-container--start">
        <div className="game-finished-container">
          <p className="title">This link is no longer active.</p>
          <p>Please request a new link from your study team.</p>
        </div>
      </div>
    );
  }

  if (passedGamesCount.status === 'loading') {
    return <Loader image={nijiLogo} />;
  }

  if (gameEnded) {
    return (
      <GameEnd
        gameConfig={gameConfig}
        resetTest={resetTest}
        results={gameResults}
        practiceData={practiceData}
      />
    );
  }

  if (passedGamesCount.status === 'error') {
    return (
      <div className="instructions-container instructions-container--start">
        <div className="game-finished-container">
          <p className="title">We could not verify your link.</p>
          <p>Please request a new link from your study team.</p>
        </div>
      </div>
    );
  }

  if (passedGamesCount.status === 'success' && passedGamesCount.data?.data?.completed) {
    return (
      <div className="instructions-container instructions-container--start">
        <div className="game-finished-container">
          <p className="title">This activity has already been completed.</p>
          <p>If you believe this is an error, contact your study team.</p>
        </div>
      </div>
    );
  }

  if (passedGamesCount.status === 'success' && passedGamesCount.data?.data?.count >= 2) {
    return (
      <div className="instructions-container instructions-container--start">
        <div className="game-finished-container">
          <p className="title">You have reached the maximum number of attempts.</p>
          <p>If you believe this is an error, contact your study team.</p>
        </div>
      </div>
    );
  }

  if (gameStarted) {
    return (
      <>
        <Game
          gameConfig={gameConfig}
          endGame={endGame}
          flashScreen={flashScreen}
        />
        <Flasher
          messageDurationSeconds={1}
          screenFlashed={screenFlashed}
          setScreenFlashed={setScreenFlashed}
        />
      </>
    );
  }

  return (
    <>
      <GameInstructions
        gameConfig={gameConfig}
        startGame={startGame}
        setPracticeResults={setPracticeResults}
        flashScreen={()=>{setScreenFlashed(true);}}
        showConsentModal={() => {}}
      />
      <Flasher
        messageDurationSeconds={1}
        screenFlashed={screenFlashed}
        setScreenFlashed={setScreenFlashed}
      />
    </>
  );
};

export default MainGame;
